export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA2154.dfb8f968.jpg";